"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderService = void 0;

var Repository_1 = __importDefault(require("./Repository"));

var entities_1 = require("../../entities");

var LegalizeSDKError_1 = __importDefault(require("../../core/utilities/LegalizeSDKError"));

var OrderService =
/** @class */
function () {
  function OrderService(baseUrl, authorization) {
    this.repository = new Repository_1.default(baseUrl);

    if (authorization) {
      this.setAuthorization(authorization);
    }
  }

  OrderService.prototype.setAuthorization = function (authorization) {
    this.repository.setHeader("authorization", authorization);
  };

  OrderService.prototype.calculate = function (marketId, placeId, skus) {
    return this.repository.calculate(marketId, placeId, skus).then(function (data) {
      var result = data === null || data === void 0 ? void 0 : data.calcOrder;
      return result.order ? Promise.resolve(new entities_1.CalculatedOrderEntity(result.order)) : Promise.reject(new LegalizeSDKError_1.default("Can not calculate order", new entities_1.CartErrorEntity(result.error)));
    });
  };

  OrderService.prototype.create = function (marketId, addressId, skus) {
    return this.repository.create(marketId, addressId, skus).then(function (data) {
      var result = data === null || data === void 0 ? void 0 : data.orderCreate;
      return result.order ? Promise.resolve(new entities_1.OrderEntity(result.order)) : Promise.reject(new LegalizeSDKError_1.default("Can not create order", new entities_1.CartErrorEntity(result.error)));
    });
  };

  OrderService.prototype.update = function (orderId, addressId, skus, applyVouchers) {
    return this.repository.update(orderId, addressId, skus, applyVouchers).then(function (data) {
      var result = data === null || data === void 0 ? void 0 : data.orderUpdate;
      return result.order ? Promise.resolve(new entities_1.OrderEntity(result.order)) : Promise.reject(new LegalizeSDKError_1.default("Can not update order", new entities_1.CartErrorEntity(result.error)));
    });
  };

  OrderService.prototype.checkout = function (orderId, paymentMethod, deliveryType, timeslotInfo) {
    return this.repository.checkout(orderId, paymentMethod, deliveryType, timeslotInfo).then(function (data) {
      var result = data === null || data === void 0 ? void 0 : data.orderCheckout;
      return result.success ? Promise.resolve(new entities_1.OrderCheckoutResponseEntity(result)) : Promise.reject(new LegalizeSDKError_1.default("Can not checkout order", new entities_1.CartErrorEntity(result.error)));
    });
  };

  OrderService.prototype.cancel = function (orderId) {
    return this.repository.cancel(orderId).then(function (data) {
      var _a;

      return Promise.resolve(Boolean((_a = data === null || data === void 0 ? void 0 : data.orderCancel) === null || _a === void 0 ? void 0 : _a.success));
    });
  };

  OrderService.prototype.findTimeslots = function (placeId, depotId) {
    return this.repository.findTimeslots(placeId, depotId).then(function (data) {
      var _a;

      return Promise.resolve((((_a = data === null || data === void 0 ? void 0 : data.timeslotsFind) === null || _a === void 0 ? void 0 : _a.scheduled) || []).map(function (schedule) {
        return new entities_1.ScheduleTimeslotEntity(schedule);
      }));
    });
  };

  OrderService.prototype.getOrderById = function (orderId) {
    return this.repository.getOrderById(orderId).then(function (data) {
      var _a, _b;

      return ((_a = data === null || data === void 0 ? void 0 : data.myOrders) === null || _a === void 0 ? void 0 : _a.list.length) ? Promise.resolve(new entities_1.OrderEntity((_b = data === null || data === void 0 ? void 0 : data.myOrders) === null || _b === void 0 ? void 0 : _b.list[0])) : Promise.reject(new LegalizeSDKError_1.default("Order not found", {
        orderId: orderId
      }));
    });
  };

  OrderService.prototype.getOrders = function (offset, limit) {
    return this.repository.getOrders(offset, limit).then(function (data) {
      var _a;

      return Promise.resolve((((_a = data === null || data === void 0 ? void 0 : data.myOrders) === null || _a === void 0 ? void 0 : _a.list) || []).map(function (order) {
        return new entities_1.OrderEntity(order);
      }));
    });
  };

  return OrderService;
}();

exports.OrderService = OrderService;